import { Component, Input } from '@angular/core';
import { DataService } from '../../services/data.service';
import { IconService } from '../../services/icon.service';
import { RowTypeName, WidgetAccountStateComponentData, WidgetAccountStateTableRow } from './widget-account-state.interface';
import { BillingTableRowType } from 'src/app/models/enums/billingTableRowType';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-widget-account-state',
  templateUrl: './widget-account-state.component.html',
  styleUrls: ['./widget-account-state.component.scss', './widget-account-state.component.en.scss']
})
export class WidgetAccountStateComponent {

  constructor(private dataService: DataService, private iconService: IconService) {}
  
  displayedColumns: string[] = ['name', 'balance', 'description', 'date'];
  displayedTypesOnMobile: BillingTableRowType[] = [BillingTableRowType.CurrentBalance, BillingTableRowType.NextVoucher];
  mockAccountDataRow: WidgetAccountStateTableRow = {
    type: BillingTableRowType.CurrentBalance,
    balance: 0
  }
  accountData : WidgetAccountStateTableRow [] = [];
  rowTypeNames: RowTypeName[] = [];
  footnoteText: string = '';
  title: string = '';
  icon: string = '';
  leftLinkText: string = '';
  leftLinkUrl: string = '';
  leftLinkTarget: string = '';
  lastPaymentMadeDateText: string = '';
  currencyName: string = '';
  nextVoucherDateText: string = '';
  noResultsMessage: string = '';
  BillingTableRowType = BillingTableRowType;
  isLoading: boolean = true;
  currentBalance: WidgetAccountStateTableRow | undefined;
  nextVoucher: WidgetAccountStateTableRow | undefined;
  isServerError: boolean = false;

  @Input() set widgetData (value: WidgetAccountStateComponentData) {
    if (value) {
      this.rowTypeNames = value.rowTypeNames;
      if (value.icon) {
        this.iconService.addIconToRegistry({
          key: value.icon,
          path: value.icon,
        });
        this.icon = value.icon;
      }
      this.title = value.title;
      this.footnoteText = value.footnoteText || '';
      this.leftLinkText = value.leftLinkText || '';
      this.leftLinkUrl = value.leftLinkUrl || '';
      this.leftLinkTarget = value.leftLinkTarget;
      this.lastPaymentMadeDateText = value.lastPaymentMadeDateText || '';
      this.currencyName = value.currencyName || '';
      this.nextVoucherDateText = value.nextVoucherDateText || '';
      this.noResultsMessage = value.noResultsMessage || '';
      //show the column only if the checkbox is enabled in umbraco
      this.displayedColumns = this.displayedColumns.filter((col) => (value as any)[`show${col.charAt(0).toUpperCase() + col.slice(1)}Column`]);
    }
  }

  ngOnInit() {
    this.accountData = Array.from({ length: 4 }, () => (this.mockAccountDataRow));
    this.getData()
  }
  
  getData() {
    let url = environment.apiUrl + '/Portal/Api/Widgets/GetAccountStateForWidget';
    let request: any = {
      cultureCode: this.dataService.getCultureCode(),
    };
    this.dataService.getDataByToken(url, request).subscribe({
      next: (responseData) => {
        this.accountData = responseData;
      },
      error: (e: any) => {
        console.error(e);
        this.isServerError = true;
      },
      complete: () => {
        this.isLoading = false;
      }
    });
  }

  getRowTypeName(type: BillingTableRowType): RowTypeName {
    const rowType = this.rowTypeNames.find(rowTypeName => rowTypeName.type === type);
    if(rowType === undefined) {
      return { type: type, description: "", title: "" };
    }
    return rowType;
  }

  convertBalanceValue(input: string): string {
    if (input.startsWith('-')) {
      return input.substring(1) + '-';
    }
    return input;
  }
}
